export enum DocumentOwnerType {
    individual = 0,
    entity = 1,
    noOwner= 2
}